import { Headphones } from '@mui/icons-material';
import { Box, SxProps, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeListenerData, selectIsB2CUser } from '@/store';
import { formatNumberCompact } from '@/utils';

interface ListenerCountProps {
  listeners?: EpisodeListenerData;
  slim?: boolean;
  inverseColor?: boolean;
  sx?: SxProps;
}

const MESSAGES = {
  org: {
    full: {
      plural: 'of your colleagues listened',
      singular: 'of your colleagues listened',
    },
    slim: { plural: 'Colleagues', singular: 'Colleague' },
  },
  global: {
    full: { plural: 'Listeners', singular: 'Listeners' },
    slim: { plural: 'Listeners', singular: 'Listeners' },
  },
};

export const ListenerCount = ({
  listeners,
  slim,
  inverseColor,
  sx,
}: ListenerCountProps) => {
  const isB2C = useSelector(selectIsB2CUser);
  const count = isB2C ? listeners?.listenersGlobal : listeners?.listenersInOrg;
  if (!count) return null;

  const iconColor = slim
    ? inverseColor
      ? 'white'
      : 'text.light'
    : 'secondary.main';
  const slimTextColor = inverseColor ? 'white' : 'text.light';
  const message =
    MESSAGES[isB2C ? 'global' : 'org'][slim ? 'slim' : 'full'][
      count === 1 ? 'singular' : 'plural'
    ];

  return (
    <Box sx={sx}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Headphones sx={{ fontSize: 16, color: iconColor }} />
        {slim ? (
          <Typography variant="caption1Bold" sx={{ color: slimTextColor }}>
            {formatNumberCompact(count)} {message}
          </Typography>
        ) : (
          <>
            <Typography variant="body3">
              <b>{formatNumberCompact(count)}</b>
            </Typography>
            <Typography variant="body3" color="text.main">
              {message}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
